import React, { createRef } from "react";
import {UserlistState} from "../types/userList.types";
import debounce from "lodash/debounce";
import { CSSProperties } from "@material-ui/core/styles/withStyles";
import "./userListStyles.scss";
import thunk from "redux-thunk";
import { withTranslation } from "react-i18next";
export default withTranslation()(class UserListComp extends React.Component <any, UserlistState>{
  private selectedRef: any;
  private debouncedFn: any;
  //private delayedCalleback: (event:  React.MouseEvent<HTMLDivElement>) => void;
    constructor(props:any){
    super(props);
    this.state = {
        showList: false,
        searchVal: '',
        teamName: props.item.teamName,
        userPic: props.item.userPic,
        userName: props.item.userName,
        userId: props.item.userId,
        usersList: null
    };

    this.selectedRef = createRef();
    this.filterOwnerFunction = this.filterOwnerFunction.bind(this);
    this.debouncedFn = debounce(this.filterOwnerFunction , 300);
    }

    static getDerivedStateFromProps(props, state){
      if(!state.usersList && props.usersList && props.usersList.length > 0){
        return {
          ...state,
          usersList: props.usersList
        }
      }
      return null;
    }

    componentDidMount() {
		  document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
		document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (this.selectedRef && !this.selectedRef.current.contains(event.target)) {
            this.setState({showList: false});
        }
    }
    
    changeSearchBox = (event, type) => {
      event.persist();
      
      if(type === "default" && !event.target.value.length){
        //fetch default user list.
        this.props.fetchUserList({ term: "" });
      }else{
        //this.filterOwnerFunction(event);
       // this.delayedCalleback(event);
        this.debouncedFn();
      }
      
    }

	  onChange = (e, val) => {
        this.setState({
          teamName: val.teamName,
          userName: val.fullName,
          userPic: val.picture,
          userId: val.userId,
          showList: false,
        }, () => {
            let params = {
              forData: {
                teamName: val.teamName,
                userName: val.fullName,
                userPic: val.picture,
                userId: val.userId,
                teamId: val.teamId,
              },
              value: this.props.displayingPeriod
            }

            if(this.props.handleFilterChange){
                this.props.handleFilterChange(e, params);
            }
        });
    }

    filterOwnerFunction(event) {
      let input, filter;
      let _this = this;
          input = document.getElementById("krOwnerSearch");
          //input = event.target.value;
      filter = input?.value.toLowerCase() || ''
      filter[0] === " " ? filter[0].replace(" ", "") : filter;
      filter[filter.length - 1] === " "
        ? filter[filter.length - 1].replace(" ", "")
        : filter;
      if (filter.length > 0) {
        this.props.fetchUserList({ term: filter });
      } else {
        this.props.fetchUserList({ term: "" });
      }
    }
  
    render(){
      const { t } = this.props;
      let wrapperStyle: CSSProperties = {
        position: 'relative', 
        display: 'inline' 
      };
      if(this.props.style){
        wrapperStyle = {
          ...wrapperStyle,
          ...this.props.style
        }
      }
        return(
        
            <div className="metricOwnerSec" id="orgResults" style={wrapperStyle} ref={this.selectedRef}>
                <div
                    className="verticalTop ownerKrName inLineBlk truncate"
                    onClick={event => {
                        this.setState({ showList: !this.state.showList });
                    }}
                    title={`${this.state.teamName} - ${this.state.userName}`}
                >
                    <img src={this.state.userPic} className="fitProfileImage" />
                    <div className="person-owner-text-arrow truncate">
                      {`${this.state.teamName} - ${this.state.userName}`}
                    </div>
                    <div className="arrowDown " />
                </div>
                {this.state.showList && (
                    <div id="myAlign" className="myownerAlign dropdown-krcontent">
                        <input
                            type="text"
                            placeholder={t("Search for people or teams")}
                            id="krOwnerSearch"
                            className="aEOwnerSearch"
                            onChange={event => this.changeSearchBox(event, "filter")}
                            onFocus={event => this.changeSearchBox(event, "default")}
                            autoFocus={true}
                        />
                        <div className="arrowDown " />
                        <div className="myownerList">
                            {this.props.usersList &&
                                this.props.usersList.map((val, i) => (
                                    <div
                                        key={`${val.userName}-${val.teamId}-${i}`}
                                        className="ownerSecic"
                                        onClick={(e) => {
                                            this.onChange(e, val);
                                        }}
                                    >
                                        <img
                                            className="ownerPic inLineBlk"
                                            src={val.picture}
                                        />{" "}
                                        <div className="info">
                                          <span className="teamName inLineBlk truncate">
                                            {val.teamName}
                                          </span>
                                          <span className="krOwnerfullname inLineBlk truncate">
                                              {val.fullName}
                                          </span>
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </div>
                )}
        </div>
        )
    }
})